import {BUDGET_TYPE, PERIOD_BUDGET_TYPE} from '../../../../constants';
import {addQuantityDecimals, formatDate} from './invoicing_generate_lines_utils';
import Util from '../../../../forecast-app/shared/util/util';
import {
	getUnitPrice,
	sortByStartDate,
} from '../../../../forecast-app/project-tab/projects/project-retainer-periods/RetainerPeriodUtil';

export const getTotalPrice = (unInvoicedProjectTimeRegs, periodStartDate, periodEndDate, periodHoursAmount, defaultRate) => {
	let totalPrice = 0;
	let addedHours = 0;
	for (let i = 0; i < unInvoicedProjectTimeRegs.length; i++) {
		const timeReg = unInvoicedProjectTimeRegs[i];
		const timeRegDate = Util.CreateMomentDate(timeReg.year, timeReg.month, timeReg.day);
		const minutesRegistered = timeReg.billableMinutesRegistered;

		if (timeRegDate >= periodStartDate && timeRegDate <= periodEndDate) {
			const addedPercentage = Math.min(1.0, (periodHoursAmount - addedHours) / (minutesRegistered / 60));
			addedHours += (minutesRegistered / 60) * addedPercentage;
			totalPrice += timeReg.price * addedPercentage;
		}
		if (addedHours >= periodHoursAmount) break;
	}
	if (addedHours < periodHoursAmount) {
		totalPrice += (periodHoursAmount - addedHours) * defaultRate;
	}

	return totalPrice;
};

export const generateLinesForFixedHoursRetainer = (intl, invoice, unInvoicedTimeRegistrationsByProject, projects, company) => {
	const invoiceLines = [];

	projects
		.filter(project => project.budgetType === BUDGET_TYPE.RETAINER)
		.forEach(project => {
			const periodsToInvoice = project.retainerPeriods.edges
				.map(edge => edge.node)
				.sort(sortByStartDate)
				.filter(
					period =>
						period.periodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS && period.periodLocked && !period.invoiced
				);

			if (periodsToInvoice.length > 0) {
				periodsToInvoice.forEach(period => {
					const periodName = `${period.name} (${formatDate(
						intl,
						Util.CreateMomentDate(period.startYear, period.startMonth, period.startDay)
					)} - ${formatDate(intl, Util.CreateMomentDate(period.endYear, period.endMonth, period.endDay))})`;
					const description = `${periodName}`;

					const unInvoicedProjectTimeRegs = unInvoicedTimeRegistrationsByProject[project.id] || [];
					let quantity = period.periodHoursAmount;

					const unitPrice = getUnitPrice({
						period,
						invoiceCurrency: invoice.currency,
						rateCard: project.rateCard,
						company,
						timeRegs: unInvoicedProjectTimeRegs.map(timeReg => {
							return {node: timeReg};
						}),
					});
					const projectId = project.id;
					const tax = invoice.tax;
					const discount = invoice.discount;
					const periodIds = [period.id];

					invoiceLines.push({
						description,
						quantity: addQuantityDecimals(quantity, company),
						unitPrice,
						projectId,
						tax,
						discount,
						periodIds,
					});
				});
			}
		});

	return invoiceLines;
};
